import React from "react";
import StatBox from "./StatBox";

function StatsCards({ config = [], totals = {}, loading, formatter }) {
  return (
    <div style={{ display: "flex", gap: 15, flexWrap: "wrap" }}>
      {config.map((item) => (
        <StatBox
          key={item.key}
          icon={item.icon}
          title={item.title}
          value={formatter ? formatter(totals[item.key]) : totals[item.key]}
          loading={loading}
        />
      ))}
    </div>
  );
}

export default StatsCards;